import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CenterAlertContact } from 'src/app/models/center-model/center-alert-contact.model';
import { EventsService } from 'src/app/services/events-service/events.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { EMPTY } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators';

@Component({
  selector: 'app-events-event-contacts-card',
  templateUrl: './events-event-contacts-card.component.html',
  styleUrls: ['./events-event-contacts-card.component.scss']
})
export class EventsEventContactsCardComponent implements OnInit, OnDestroy {

  @Input() alert;
  basicDataForm = new FormGroup({
    lowBatteryAlert: new FormControl({value: true, disabled: true}),
    offlineAlert: new FormControl({value: true, disabled: true}),
    paperOutAlert: new FormControl({value: true, disabled: true}),
    printOutAlert: new FormControl({value: true, disabled: true}),
    contactForm: new FormGroup({
      contactName: new FormControl(null, Validators.required),
      contactMail: new FormControl(null, [Validators.required, Validators.email]),
      contactPhone: new FormControl(null, Validators.required)
    })
  });
  updateAlertContactsSubscription: Subscription;

  constructor(private eventsService: EventsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() { }

  public addContact() {
    const valid = this.validateForm();
    if (valid === true) {
      const contact = new CenterAlertContact(null, this.basicDataForm.get('contactForm').get('contactMail').value, this.basicDataForm.get('contactForm').get('contactName').value, this.basicDataForm.get('contactForm').get('contactPhone').value);
      this.alert.centerAlertContacts.push(contact);
      this.updateAlertContacts(this.alert.centerAlertContacts);
    } else {
      this.snackbarService.open(valid, 'error');
    }
  }

  public deleteContact(contact) {
    const contacts = this.alert.centerAlertContacts.filter(c => c.ContactInternalId !== contact.ContactInternalId);
    this.updateAlertContacts(contacts);
  }

  private updateAlertContacts(contacts) {
    this.updateAlertContactsSubscription = this.eventsService.updateAlertContacts(this.alert.InternalId, contacts).pipe(
      tap(o => this.resetAddContactForm()),
      tap(o => this.eventsService.refreshAlert()),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private resetAddContactForm() {
    this.basicDataForm.get('contactForm').patchValue({
      contactName: null,
      contactMail: null,
      contactPhone: null
    });
  }

  private validateForm() {
    if (!this.basicDataForm.get('contactForm').get('contactName').valid) {
      return 'events-page.snackbar messages.contact name required error';
    } else if (!this.basicDataForm.get('contactForm').get('contactMail').valid && !this.basicDataForm.get('contactForm').get('contactPhone').valid) {
      return 'events-page.snackbar messages.email or sms required error';
    } else {
      return true;
    }
  }

  ngOnDestroy() {
    if (this.updateAlertContactsSubscription) { this.updateAlertContactsSubscription.unsubscribe(); }
  }
}
